/* شاشة الديسكتوب — المحرر للموبايل فقط ≥900px
 * + بطاقة حساب + QR دخول بنفس الجلسة على الموبايل */
import { $, toast } from './core.js';

export const DESKTOP_GATE_MQ = '(min-width: 900px)';

const QR_RING_LEN = 339.292;

let gateUser = null;
let deviceUrl = null;
let deviceJti = null;
let deviceWatch = null;
let deviceExpiresAt = 0;
let deviceTtlSec = 120;
let refreshTimer = null;
let countdownTimer = null;
let pollTimer = null;
let qrClaimed = false;

function bypassDesktopGate() {
  try {
    if (new URLSearchParams(location.search).get('mobile') === '1') return true;
    if (localStorage.getItem('omdaa.forceMobile') === '1') return true;
  } catch { /* ignore */ }
  return false;
}

export function shouldBlockDesktopApp() {
  if (bypassDesktopGate()) return false;
  return typeof window !== 'undefined' && window.matchMedia(DESKTOP_GATE_MQ).matches;
}

function mobileOpenUrl() {
  const { origin, pathname } = location;
  return `${origin}${pathname || '/'}`.replace(/\/?$/, '/');
}

function pwaInstallUrl() {
  const base = mobileOpenUrl().replace(/\?.*$/, '').replace(/#.*$/, '');
  const u = new URL(base);
  u.searchParams.set('install', 'pwa');
  return u.toString();
}

function setQrFromText(text, { size = 200 } = {}) {
  const img = $('#dmg-qr');
  if (!img) return;
  img.width = size;
  img.height = size;
  img.src = `/api/qr.svg?size=${size}&text=${encodeURIComponent(text)}`;
  img.alt = `QR — ${text.slice(0, 80)}`;
}

function setQrUiState(state, message) {
  const status = $('#dmg-qr-status');
  const statusText = $('#dmg-qr-status-text');
  const frame = $('#dmg-qr-frame');
  const success = $('#dmg-qr-success');
  if (status) status.dataset.state = state;
  if (statusText && message) statusText.textContent = message;
  if (frame) {
    frame.classList.toggle('is-pending', state === 'pending');
    frame.classList.toggle('is-claimed', state === 'claimed');
  }
  if (success) {
    const show = state === 'claimed';
    success.hidden = !show;
    success.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
}

function updateQrRingProgress() {
  const ring = $('#dmg-qr-ring-fg');
  if (!ring || !deviceExpiresAt || qrClaimed) return;
  const totalMs = deviceTtlSec * 1000;
  const left = Math.max(0, deviceExpiresAt - Date.now());
  const ratio = Math.min(1, left / totalMs);
  ring.style.strokeDashoffset = String(QR_RING_LEN * (1 - ratio));
  if (left <= 20000) ring.style.stroke = '#fbbf24';
  else ring.style.stroke = '#34d399';
}

function stopPoll() {
  if (pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
}

function stopDeviceTimers() {
  if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null; }
  if (countdownTimer) { clearInterval(countdownTimer); countdownTimer = null; }
  stopPoll();
}

function onDeviceQrClaimed() {
  if (qrClaimed) return;
  qrClaimed = true;
  stopPoll();
  if (refreshTimer) { clearTimeout(refreshTimer); refreshTimer = null; }
  setQrUiState('claimed', 'تم المسح — الجوال يدخل الآن بنفس حسابك');
  toast('تم مسح الرمز — Omdaa Code يفتح على جوالك', 'ok', 4200);
  const ring = $('#dmg-qr-ring-fg');
  if (ring) {
    ring.style.stroke = '#22c55e';
    ring.style.strokeDashoffset = '0';
  }
  setTimeout(() => {
    if (gateUser && qrClaimed) void refreshDeviceQr({ silent: true });
  }, 12000);
}

async function pollDeviceQrStatus() {
  if (!deviceJti || !gateUser || qrClaimed) return;
  try {
    const qs = new URLSearchParams({ jti: deviceJti });
    if (deviceWatch) qs.set('watch', deviceWatch);
    const res = await fetch(`/api/sso/device-qr/status?${qs}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) return;
    const data = await res.json();
    if (data.status === 'claimed') {
      onDeviceQrClaimed();
      return;
    }
    if (data.status === 'expired') {
      setQrUiState('expired', 'انتهت صلاحية الرمز — جاري التحديث…');
      void refreshDeviceQr({ silent: true });
    }
  } catch { /* ignore */ }
}

function startPoll() {
  stopPoll();
  if (!deviceJti || !gateUser) return;
  qrClaimed = false;
  void pollDeviceQrStatus();
  pollTimer = setInterval(() => void pollDeviceQrStatus(), 2000);
}

function setQrGuest() {
  const url = pwaInstallUrl();
  deviceUrl = url;
  deviceJti = null;
  deviceWatch = null;
  qrClaimed = false;
  stopDeviceTimers();
  setQrFromText(url);
  setQrUiState('idle', 'امسح لفتح المحرر على الجوال');
  const title = $('#dmg-qr-title');
  const sub = $('#dmg-qr-sub');
  const acc = $('#dmg-qr-account');
  const timer = $('#dmg-qr-timer');
  const refresh = $('#dmg-qr-refresh');
  const status = $('#dmg-qr-status');
  if (title) title.textContent = 'امسح من جوالك للفتح';
  if (sub) sub.textContent = 'يفتح المحرر — سجّل الدخول من الهاتف إن لزم';
  if (acc) acc.hidden = true;
  if (timer) timer.hidden = true;
  if (refresh) refresh.hidden = true;
  if (status) status.hidden = true;
  const urlEl = $('#dmg-open-url');
  if (urlEl) urlEl.textContent = mobileOpenUrl().replace(/^https?:\/\//, '');
}

function updateCountdown() {
  const secEl = $('#dmg-qr-sec');
  const timer = $('#dmg-qr-timer');
  if (!secEl || !timer || !deviceExpiresAt) return;
  const left = Math.max(0, Math.ceil((deviceExpiresAt - Date.now()) / 1000));
  secEl.textContent = String(left);
  timer.classList.toggle('is-urgent', left <= 20 && !qrClaimed);
  updateQrRingProgress();
  if (!qrClaimed && left <= 0) void refreshDeviceQr({ silent: true });
}

async function refreshDeviceQr({ silent = false } = {}) {
  const overlay = $('#dmg-qr-overlay');
  if (overlay) overlay.hidden = false;
  qrClaimed = false;
  try {
    const res = await fetch('/api/sso/device-qr', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'me', Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) throw new Error('qr');
    const data = await res.json();
    if (!data?.url) throw new Error('no-url');

    deviceUrl = data.url;
    deviceJti = data.jti || null;
    deviceWatch = data.watch || null;
    deviceExpiresAt = data.expiresAt || (Date.now() + (data.expiresIn || 120) * 1000);
    deviceTtlSec = data.expiresIn || 120;
    setQrFromText(data.url, { size: 200 });

    const u = data.user || gateUser || {};
    const name = u.fullName || u.username || 'حسابك';
    const email = u.email || '';
    const title = $('#dmg-qr-title');
    const sub = $('#dmg-qr-sub');
    const acc = $('#dmg-qr-account');
    const timer = $('#dmg-qr-timer');
    const refresh = $('#dmg-qr-refresh');
    const urlEl = $('#dmg-open-url');
    const status = $('#dmg-qr-status');

    if (title) title.textContent = 'امسح للدخول بنفس الحساب';
    if (sub) sub.textContent = 'مرة واحدة · يفتح Omdaa Code على جوالك وأنت مسجّل';
    if (acc) {
      acc.hidden = false;
      acc.textContent = email ? `${name} · ${email}` : name;
    }
    if (timer) timer.hidden = false;
    if (refresh) refresh.hidden = false;
    if (status) status.hidden = false;
    if (urlEl) urlEl.textContent = 'رابط دخول آمن · مرة واحدة';

    setQrUiState('pending', 'بانتظار المسح من كاميرا الجوال…');

    stopDeviceTimers();
    updateCountdown();
    updateQrRingProgress();
    countdownTimer = setInterval(updateCountdown, 1000);
    startPoll();
    const ms = Math.max(15000, deviceExpiresAt - Date.now() - 15000);
    refreshTimer = setTimeout(() => void refreshDeviceQr({ silent: true }), ms);

    if (!silent) toast('تم تحديث رمز الدخول للجوال', 'ok', 2200);
  } catch {
    setQrGuest();
    if (!silent) toast('تعذّر إنشاء رمز الدخول — افتح الرابط يدوياً', 'err', 3500);
  } finally {
    if (overlay) overlay.hidden = true;
  }
}

function bindCopyUrl() {
  const btn = $('#dmg-copy-url');
  btn?.addEventListener('click', async () => {
    const url = deviceUrl || pwaInstallUrl();
    try {
      await navigator.clipboard.writeText(url);
      toast(
        gateUser
          ? 'تم نسخ رابط الدخول — افتحه من جوالك خلال دقيقتين'
          : 'تم نسخ الرابط — افتحه من جوالك',
        'ok',
        3200,
      );
    } catch {
      toast(url, 'ok', 5000);
    }
  });
}

function bindPwaInstallLinks() {
  const installUrl = pwaInstallUrl();
  const link = $('#dmg-install-link');
  if (link) {
    link.href = installUrl;
    link.title = installUrl;
  }
  $('#dmg-install-copy')?.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(installUrl);
      toast('تم نسخ رابط التثبيت — افتحه من Chrome/Safari على الجوال', 'ok', 4000);
    } catch {
      toast(installUrl, 'ok', 6000);
    }
  });
}

function bindQrRefresh() {
  $('#dmg-qr-refresh')?.addEventListener('click', () => void refreshDeviceQr({ silent: false }));
}

function bindSessionRefreshOnFocus() {
  let lastSoftSync = 0;
  const reload = () => {
    if (!shouldBlockDesktopApp()) return;
    const now = Date.now();
    if (now - lastSoftSync < 25000) return;
    lastSoftSync = now;
    void loadGateSession({ remintQr: false });
  };
  window.addEventListener('pageshow', (ev) => {
    if (ev.persisted) reload();
  });
  window.addEventListener('focus', reload);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') reload();
  });
}

function watchViewportUnlock() {
  const mq = window.matchMedia(DESKTOP_GATE_MQ);
  const onChange = (ev) => {
    if (!ev.matches && shouldBlockDesktopApp() === false) location.reload();
  };
  if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
  else mq.addListener(onChange);
}

function initialsFrom(name, email, username) {
  const src = String(name || username || email || '?').trim();
  if (!src) return '?';
  const parts = src.replace(/@.*/, '').split(/[\s._-]+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return src.slice(0, 2).toUpperCase();
}

function resolveAvatarUrl(avatar) {
  if (!avatar || typeof avatar !== 'string') return null;
  let a = avatar.trim();
  if (!a) return null;
  if (a.startsWith('/')) a = `https://omdaa.com${a}`;
  else if (!/^https?:\/\//i.test(a) && !a.startsWith('data:')) a = `https://omdaa.com/${a}`;
  if (/googleusercontent\.com|ggpht\.com/i.test(a)) {
    a = a.replace(/=s\d+-c\b/i, '=s192-c').replace(/=s\d+\b/i, '=s192');
  }
  return a;
}

function showGuest() {
  gateUser = null;
  stopDeviceTimers();
  const guest = $('#dmg-guest');
  const account = $('#dmg-account');
  const note = $('#dmg-signed-note');
  if (account) account.hidden = true;
  if (note) note.hidden = true;
  if (guest) guest.hidden = false;
  setQrGuest();
}

function setProviderChip(user) {
  const el = $('#dmg-account-provider');
  if (!el) return;
  if (user.authProvider === 'google' || user.googleSub) {
    el.hidden = false;
    el.innerHTML = '<svg width="12" height="12" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.203 36 24 36c-5.514 0-10-4.486-10-10s4.486-10 10-10c2.499 0 4.785.923 6.523 2.443l5.657-5.657C34.046 10.053 29.268 8 24 8 14.611 8 7 15.611 7 25s7.611 17 17 17c9.389 0 17-7.611 17-17 0-1.061-.098-2.094-.389-3.083z"/><path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 13 24 13c2.499 0 4.785.923 6.523 2.443l5.657-5.657C34.046 10.053 29.268 8 24 8 16.318 8 9.656 13.337 6.306 14.691z"/><path fill="#4CAF50" d="M24 43c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 34.091 26.715 35 24 35c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 43 24 43z"/><path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.061-.098-2.094-.389-3.083z"/></svg> Google';
  } else if (user.authProvider === 'omdaa' || user.mainUserId) {
    el.hidden = false;
    el.textContent = 'Omdaa';
  } else {
    el.hidden = true;
    el.textContent = '';
  }
}

function loadAvatarImage(avEl, initialsEl, url, name) {
  if (!avEl || !url) {
    if (avEl) avEl.hidden = true;
    if (initialsEl) initialsEl.hidden = false;
    return;
  }
  avEl.classList.remove('is-loaded');
  avEl.hidden = false;
  avEl.alt = name || 'الصورة الشخصية';
  avEl.referrerPolicy = 'no-referrer';
  avEl.crossOrigin = 'anonymous';

  const done = (ok) => {
    if (ok) {
      avEl.classList.add('is-loaded');
      if (initialsEl) initialsEl.hidden = true;
    } else {
      avEl.hidden = true;
      avEl.classList.remove('is-loaded');
      if (initialsEl) initialsEl.hidden = false;
    }
  };

  avEl.onload = () => done(true);
  avEl.onerror = () => {
    if (avEl.dataset.retry !== '1') {
      avEl.dataset.retry = '1';
      avEl.removeAttribute('crossorigin');
      avEl.src = url + (url.includes('?') ? '&' : '?') + 'v=2';
      return;
    }
    done(false);
  };
  avEl.dataset.retry = '';
  avEl.src = url;
}

function showAccount(user, { remintQr = true } = {}) {
  const guest = $('#dmg-guest');
  const account = $('#dmg-account');
  const note = $('#dmg-signed-note');
  if (guest) guest.hidden = true;
  if (!account || !user) return showGuest();

  patchAccountCard(user);
  const name = user.fullName || user.displayName || user.username || 'عضو Omdaa';
  const initialsEl = $('#dmg-account-initials');
  if (initialsEl) initialsEl.hidden = false;

  account.hidden = false;
  account.classList.add('is-ready');
  if (note) {
    note.hidden = false;
    note.textContent = 'امسح رمز QR للدخول على جوالك بنفس هذا الحساب فوراً — بدون إعادة تسجيل.';
  }
  document.title = `${name} · Omdaa Code — للموبايل فقط`;
  if (remintQr) void refreshDeviceQr({ silent: true });
}

function patchAccountCard(user) {
  if (!user) return;
  gateUser = user;
  const name = user.fullName || user.displayName || user.username || 'عضو Omdaa';
  const email = user.email || '';
  const nameEl = $('#dmg-account-name');
  const emailEl = $('#dmg-account-email');
  const initialsEl = $('#dmg-account-initials');
  const avEl = $('#dmg-account-avatar');
  if (nameEl) nameEl.textContent = name;
  if (emailEl) {
    emailEl.textContent = email || `@${user.username || 'user'}`;
    emailEl.hidden = !email && !user.username;
  }
  if (initialsEl) {
    initialsEl.textContent = initialsFrom(name, email, user.username);
    initialsEl.hidden = false;
  }
  setProviderChip(user);
  loadAvatarImage(avEl, initialsEl, resolveAvatarUrl(user.avatar), name);
}

async function loadGateSession({ remintQr = true } = {}) {
  const account = $('#dmg-account');
  if (account) account.classList.add('is-loading');
  try {
    const res = await fetch('/api/me', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'me', Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!res.ok) {
      showGuest();
      return;
    }
    const data = await res.json();
    if (data?.user) {
      if (gateUser && gateUser.id === data.user.id && !remintQr) {
        patchAccountCard(data.user);
        return;
      }
      showAccount(data.user, { remintQr });
    } else showGuest();
  } catch {
    showGuest();
  } finally {
    if (account) account.classList.remove('is-loading');
  }
}

/**
 * @returns {boolean} true = تم إيقاف تحميل التطبيق (ديسكتوب)
 */
export function initDesktopMobileGate() {
  if (!shouldBlockDesktopApp()) return false;

  const gate = $('#desktop-mobile-gate');
  if (gate) gate.hidden = false;

  document.body.classList.add('desktop-gate-active');
  $('#app')?.setAttribute('hidden', '');
  $('#login')?.setAttribute('hidden', '');

  setQrGuest();
  bindCopyUrl();
  bindPwaInstallLinks();
  bindQrRefresh();
  bindSessionRefreshOnFocus();
  watchViewportUnlock();
  void loadGateSession();

  document.title = 'Omdaa Code — للموبايل فقط';
  return true;
}
